import { eventBus } from '../services';

const FreeShippingNotice = (items) => {
  const CartService = Shopify.cartService;

  const { shippingDataset, noticeContainer, progressContainer } = items;

  const defaultData = {
    threshold: 12,
    thresholdType: 'quantity',
    noticePassed: 'You have free shipping!',
    noticeAlmostPassed: 'Add __AMOUNT__ more to get free shipping!',
  };

  const data = { ...defaultData, ...shippingDataset };
  data.threshold = parseInt(data.threshold);

  const showProgressBar = progressContainer ? true : false;
  const showNotice = noticeContainer ? true : false;

  const init = () => {
    if (!showNotice) {
      console.error('No notice container found');
      return;
    }

    const type = data.thresholdType;

    if (typeof Shopify.theme.cartOnLoad) {
      cartCheck(Shopify.theme.cartOnLoad, type);
    }

    eventBus.on(eventBus.types.CartUpdated, function (data) {
      cartCheck(CartService.cart, type);
    });
  };

  const cartCheck = (cart, type) => {
    let notice = data.noticePassed;
    const isPrice = type == 'price';
    let cartValue = isPrice ? cart.total_price / 100 : cart.item_count;
    const excludedProducts = data.excludedProducts;

    if (
      typeof excludedProducts !== 'undefined' &&
      excludedProducts.length > 0
    ) {
      cartValue = isPrice ? 0 : cartValue;

      cart.items.forEach((item) => {
        if (!excludedProducts.includes(item.produce_id)) {
          if (isPrice) {
            cartValue += item.final_line_price / 100;
          } else {
            cartValue += item.quantity;
          }
        }
      });
    }

    if (data.threshold > cartValue) {
      notice = replaceText(cartValue);
    }

    noticeContainer.innerHTML = notice;

    if (showProgressBar) {
      setProgressBar(cartValue);
    }
  };

  const replaceText = (value) => {
    let str;
    const amount = data.threshold - value;
    const useAmount =
      data.threshholdType == 'price' ? amount.toFixed(2) : amount;
    str = data.noticeAlmostPassed.replace('__AMOUNT__', useAmount);

    if (data.unitType && str.includes('__UNIT__')) {
      const unit = data.unitType;
      let pluralUnit;

      if (amount > 1) {
        if (data.unitType.endsWith('y')) {
          pluralUnit = unit.slice(0, -1) + 'ies';
        } else if (
          unit.endsWith('s') ||
          unit.endsWith('sh') ||
          unit.endsWith('ch') ||
          unit.endsWith('x') ||
          unit.endsWith('z')
        ) {
          pluralUnit = unit + 'es';
        } else if (unit.endsWith('f')) {
          pluralUnit = unit.slice(0, -1) + 'ves';
        } else if (unit.endsWith('fe')) {
          pluralUnit = unit.slice(0, -2) + 'ves';
        } else {
          pluralUnit = unit + 's';
        }
      } else {
        pluralUnit = unit;
      }

      str = str.replace('__UNIT__', pluralUnit);
    }

    return str;
  };

  const setProgressBar = (value) => {
    const percent = ((value / data.threshold) * 100).toFixed(4);

    if (value == 0) {
      progressContainer.style.width = '0%';
      return;
    }

    if (percent > 100) {
      progressContainer.style.width = '100%';
      return;
    }

    progressContainer.style.width = `${percent}%`;
  };

  init();
};

export default FreeShippingNotice;
